import { useEventListenerV2 } from './use-event-listener-v2.esm.js';
import { wrapPointerEventHandler, getPointerEventName } from '../utils/pointer-event.esm.js';

/**
 * @internal
 */

function usePointerEvent(env, eventName, handler, options) {
  return useEventListenerV2(getPointerEventName(eventName), wrapPointerEventHandler(handler, eventName === 'pointerdown'), env, options);
}

export { usePointerEvent };
//# sourceMappingURL=use-pointer-event.esm.js.map
